import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * App-wide toasts (sonner), themed from the brand tokens so light/dark follow automatically.
 * Trailing `!` = Tailwind 4's "important" (sonner ships its own styles).
 */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="bottom-center"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'rounded-panel! border! border-line-strong! bg-surface! text-ink! shadow-popover! font-sans!',
          description: 'text-ink-3!',
          actionButton: 'rounded-full! bg-accent! text-on-accent! font-semibold!',
          cancelButton: 'rounded-full! bg-surface-2! text-ink!',
          success: '[&_[data-icon]]:text-good-ink!',
          error: '[&_[data-icon]]:text-critical-ink!',
          warning: '[&_[data-icon]]:text-warning-ink!',
        },
      }}
      {...props}
    />
  );
}

export { toast } from 'sonner';
